export enum DeviceType {
  MOBILE = 'mobile',
  DESKTOP = 'desktop',
}

export enum CmsContentType {
  LEGAL_NOTICE = 'legal_notice',
  TERMS_OF_SERVICE = 'terms_of_service',
  PRIVACY_POLICY = 'privacy_policy',
}

export enum CmsPageContentType {
  APP_GLOBAL_TYPE = 'app_global_type',
  POP_IN = 'pop_in',
  CONTRACT_DOCUMENTS = 'contract_documents',
  GENERIC_SIDE_NAV_PDV = 'generic_side_nav_pdv',
  KUBRICK_JOURNEY_HOME_PAGE = 'kubrick_journey_home_page',
  LOADING_LAYOUT_CONTENT = 'kubrick_loading_Layout_Content',
  PARKOUR_CLIENT_DETAILS_CONFIRMATION = 'parkour_client_details_confirmation',
  KUBRICK_DAMAGED_GOOD_USER_CREATION = 'kubrick_damaged_good_user_creation',
  KUBRICK_DAMAGED_GOOD_CREATION = 'kubrick_damaged_good_creation',
  KUBRICK_DAMAGED_GOOD_FAMILY = 'kubrick_damaged_good_family',
  KUBRICK_DAMAGED_GOOD_DATE = 'kubrick_damaged_good_date',
  KUBRICK_DAMAGED_GOOD_IMEI_VALIDATION = 'kubrick_damaged_good_imei_validation',
  REFERENTIAL_ITEMS = 'referential_items',
  KUBRICK_INFORMATION_FOR_SUPPORTING_DOCUMENTS = 'kubrick_information_for_supporting_documents',
  KUBRICK_DAMAGED_GOOD_SERIAL_NUMBER_VALIDATION = 'kubrick_damaged_good_serial_number_validation',
  KUBRICK_DAMAGED_GOOD_SELECTION = 'kubrick_damaged_good_selection',
  KUBRICK_CLAIM_LOCATION = 'kubrick_claim_location',
  KUBRICK_UPLOAD_DECLARATION = 'kubrick_upload_declaration',
  KUBRICK_DAMAGED_GOOD_USER_CONFIRMATION = 'kubrick_damaged_good_user_confirmation',
  KUBRICK_CLAIM_TRIGGER_NATURE = 'kubrick_claim_trigger_nature',
  KUBRICK_EXTERNAL_DAMAGE_CONFIRMATION = 'kubrick_external_damage_confirmation',
  KUBRICK_CLAIM_RESULT_SELECTION = 'kubrick_claim_result_selection',
  KUBRICK_CHOOSE_DAMAGED_GOODS = 'kubrick_choose_damaged_goods',
  KUBRICK_CLAIM_RESULT_FREE_ENTRY = 'kubrick_claim_result_free_entry',
  KUBRICK_DAMAGED_GOOD_DYSFUNCTION_SELECTION = 'kubrick_damaged_good_dysfunction_selection',
  KUBRICK_DAMAGED_GOOD_DYSFUNCTION_FREE_ENTRY = 'kubrick_damaged_good_dysfunction_free_entry',
  KUBRICK_DAMAGED_GOOD_CIRCONSTANCES = 'kubrick_damaged_good_circonstances',
  KUBRICK_DAMAGED_GOOD_ACCESSORIES_VALIDATION = 'kubrick_damaged_good_accessories_validation',
  KUBRICK_DECLARATION_SUMMARY = 'kubrick_declaration_summary',
  KUBRICK_CLIENT_DETAILS_CONFIRMATION = 'kubrick_client_details_confirmation',
  KUBRICK_IMPROVEMENT_QUALITY = 'kubrick_improvement_quality',
  KUBRICK_UPDATE_CLIENT_DETAILS = 'kubrick_update_client_details',
  KUBRICK_DECLARATION_CONFIRMATION = 'kubrick_declaration_confirmation',
  KUBRICK_COVER_SELECTION = 'kubrick_cover_selection',
  KUBRICK_CONTACT_MODE = 'kubrick_contact_mode',
  KUBRICK_CONTACT_FORM = 'kubrick_contact_form',
  KUBRICK_CLAIM_DECLARE_CONTACT_FORM = 'kubrick_claim_declare_contact_form',
  KUBRICK_CONFIRM_EMAIL = 'kubrick_confirm_email',
  KUBRICK_NEED_HELP = 'kubrick_need_help',
  KUBRICK_TRAVEL_ASSISTANCE = 'kubrick_travel_assistance',
  KUBRICK_DAMAGED_GOOD_PROPER_USE_CONFIRMATION = 'kubrick_damaged_good_proper_use_confirmation',
  KUBRICK_OTHER_CLAIM_TRIGGER_NATURE = 'kubrick_other_claim_trigger_nature',
  KUBRICK_DAMAGED_GOOD_PROPER_FUNCTIONING_CONFIRMATION = 'kubrick_damaged_good_proper_functioning_confirmation',
  KUBRICK_DEVICE_DOES_NOT_TURN_ON_CONFIRMATION = 'kubrick_device_does_not_turn_on_confirmation',
  KUBRICK_INVALID_DAMAGED_GOOD = 'kubrick_invalid_damaged_good',
  KUBRICK_OUT_OF_WARRANTY = 'kubrick_out_of_warranty',
  KUBRICK_RECLAMATION_TO_MERCHANT = 'kubrick_reclamation_to_merchant',
  KUBRICK_OVERTAKING_DATE = 'kubrick_overtaking_date',
  KUBRICK_HAVE_IN_PROGRESS_CLAIM = 'kubrick_have_in_progress_claim',
  KUBRICK_CARD_ELIGIBILITY_MODAL = 'kubrick_card_eligibility_modal',
  KUBRICK_MULTI_CLAIM_MODAL = 'kubrick_multiclaim_modal',
  KUBRICK_BIN_ELIGIBILITY_MODAL = 'kubrick_bin_eligibility_modal',
  KUBRICK_COVER_ELIGIBILITY_MODAL = 'kubrick_cover_eligibility_modal',
  KUBRICK_DAMAGED_GOOD_REPARATION_PERIOD_CONFIRMATION = 'kubrick_damaged_good_reparation_period_confirmation',
  KUBRICK_DAMAGED_GOOD_REPARATION_PERIOD_CONFIRMATION_APPLE = 'kubrick_damaged_good_reparation_period_confirmation_ap',
  KUBRICK_DECLARATION_CANNOT_BE_REGISTERED = 'kubrick_declaration_cannot_be_registered',
  KUBRICK_VOUCHER_GENERATION_CONFIRMATION = 'kubrick_transport_voucher_generation_confirmation',
  KUBRICK_DAMAGE_OBSERVED_FREE_ENTRY = 'kubrick_damage_observed_free_entry',
  KUBRICK_STOLEN_TYPE_SELECTION = 'kubrick_stolen_type_selection',
  KUBRICK_PHYSICAL_VIOLENCE_CONFIRMATION = 'kubrick_physical_violence_confirmation',
  KUBRICK_THEFT_INSURED_PERSON_ELIGIBILITY = 'kubrick_theft_insured_person_eligibility',
  KUBRICK_THEFT_PLACE_SELECTION = 'kubrick_theft_place_selection',
  KUBRICK_THEFT_ADDRESS_VALIDATION = 'kubrick_theft_address_validation',
  KUBRICK_THEFT_ACCESSORIES_VALIDATION = 'kubrick_theft_accessories_validation',
  KUBRICK_THEFT_POLICE_REPORT_CONFIRMATION = 'kubrick_theft_police_report_confirmation',
  KUBRICK_DEVICE_SIM_CARD_IN_OPPOSITION_CONFIRMATION = 'kubrick_device_sim_card_in_opposition_confirmation',
  KUBRICK_REMPLACEMENT_DEVICE_NEW_SIM_REQUEST = 'kubrick_remplacement_device_new_sim_request',
  KUBRICK_BURGLARY_DEVICE_SELECTION = 'kubrick_burglary_device_selection',
  KUBRICK_BURGLARY_LOCATION_ACTIVE_CONFIRMATION = 'kubrick_burglary_location_active_confirmation',
  KUBRICK_EXTERNAL_PRODUCT_VISIBLE_CONFIRMATION = 'kubrick_external_product_visible_confirmation',
  KUBRICK_CLANDESTINE_INTRODUCTION_PLACE_SELECTION = 'kubrick_clandestine_introduction_place_selection',
  KUBRICK_INTRODUCTION_CLANDESTINE_PLACE_OCCUPIED_CONFIRMATION = 'kubrick_introduction_clandestine_place_occupied_confirmation',
  KUBRICK_PRODUCT_IN_HAND_CONFIRMATION = 'kubrick_product_in_hand_confirmation',
  KUBRICK_PRODUCT_IN_BAG_CONFIRMATION = 'kubrick_product_in_bag_confirmation',
  KUBRICK_PRODUCT_IN_POCKET_CONFIRMATION = 'kubrick_product_in_pocket_confirmation',
  KUBRICK_BENEFIT_TYPE_SELECTION = 'kubrick_benefit_type_selection',
  KUBRICK_BENEFIT_DEPOSIT_METHOD = 'kubrick_benefit_deposit_method',
  KUBRICK_DEVICE_PATTERN_LOCK = 'kubrick_device_pattern_lock',
  KUBRICK_REGISTERED_STATEMENT = 'kubrick_registered_statement',
  KUBRICK_CONFIRMED_DECLARATION = 'kubrick_confirmed_declaration',
  KUBRICK_TRANSPORT_VOUCHER_GENERATION_VALIDATION = 'kubrick_transport_voucher_generation_validation',
  KUBRICK_TRANSPORT_VOUCHER_GENERATION_INFORMATION = 'kubrick_transport_voucher_generation_information',
  KUBRICK_UPDATE_BENEFIT_ADDRESS_DETAILS = 'kubrick_update_benefit_address_details',
  KUBRICK_INSTRUCTIONS_FOR_PACKING = 'kubrick_instructions_for_packing',
  KUBRICK_TRANSPORT_VOUCHER_GENERATION = 'kubrick_transport_voucher_generation',
  KUBRICK_BENEFIT_INFORMATIVE_MESSAGE_DATA_SECURITY = 'kubrick_benefit_informative_message_data_security',
  KUBRICK_REGISTERED_STATEMENT_WITH_ANNOUNCEMENT = 'kubrick_registered_statement_with_announcement',
  KUBRICK_BENEFIT_POINT_SELECTION = 'kubrick_benefit_point_selection',
  KUBRICK_BENEFIT_CHOSEN_RELAY_POINT_VALIDATION = 'kubrick_benefit_chosen_relay_point_validation',
  KUBRICK_BENEFIT_CHOSEN_PROXIMITY_POINT_VALIDATION = 'kubrick_benefit_chosen_proximity_point_validation',
  KUBRICK_INSTRUCTIONS_FOR_DEACTIVATING_FIND_MY_IPHONE = 'kubrick_instructions_for_deactivating_find_my_iphone',
  KUBRICK_DEACTIVATE_DEVICE_GEOLOCATION_CONFIRMATION = 'kubrick_deactivate_device_geolocation_confirmation',
  KUBRICK_CONTACT_MANAGEMENT_SERVICE = 'kubrick_contact_management_service',
  KUBRICK_DEADLINE_REMINDER_CONFIRMATION = 'kubrick_deadline_reminder_confirmation',
  KUBRICK_COMPLAINED_TO_MERCHANT_CONFIRMATION = 'kubrick_complained_to_merchant_confirmation',
  KUBRICK_CAPITAL_SHIPPING_ADDRESS_CONFIRMATION = 'kubrick_capital_shipping_address_confirmation',
  KUBRICK_CLAIM_DECLARATION_DATE = 'kubrick_claim_declaration_date',
  KUBRICK_CONCERNED_ELEMENT_SELECTION = 'kubrick_concerned_element_selection',
  KUBRICK_COMPLAINED_TO_POLICE_REMINDER = 'kubrick_complained_to_police_reminder',
  KUBRICK_EXTERNAL_REFERENCE = 'kubrick_external_reference',
  KUBRICK_RELATIONSHIP_TO_THE_VICTIM = 'kubrick_relationship_to_the_victim',
  KUBRICK_CUSTOMER_INFORMATION = 'kubrick_customer_information',
  KUBRICK_ANOTHER_INSURER = 'kubrick_another_insurer',
  KUBRICK_DECLARE_ANOTHER_DAMAGE = 'kubrick_declare_another_damage',
  KUBRICK_CUSTOMER_CREDIT_CARD = 'kubrick_customer_credit_card',
  KUBRICK_DAMAGED_GOOD_TIME = 'kubrick_damaged_good_time',
  KUBRICK_CONDITION_OF_PROPERTY = 'kubrick_condition_of_property',
  KUBRICK_CONCERNED_DAMAGED_GOOD = 'kubrick_concerned_damaged_good',
  KUBRIC_DAMAGED_GOOD_PURCHASE_DATE = 'kubrick_damaged_good_purchase_date',
  KUBRICK_METHOD_OF_PAYMENT_CONFIRMATION = 'kubrick_method_of_payment_confirmation',
  KUBRICK_PURCHASE_VALUE = 'kubrick_purchase_value',
  KUBRICK_CUSTOMER_SPECIFY_PROPERTY = 'kubrick_customer_specify_property',
  KUBRICK_CLAIM_DOCUMENT = 'kubrick_claim_document',
}

export const Avatars = [
  {
    name: 'Anna',
  },
  {
    name: 'Claire',
  },
  {
    name: 'Elena',
  },
  {
    name: 'Emma',
  },
  {
    name: 'Jessica',
  },
  {
    name: 'Julia',
  },
  {
    name: 'Justine',
  },
  {
    name: 'Kim',
  },
  {
    name: 'Lola',
  },
  {
    name: 'Nina',
  },
  {
    name: 'Sarah',
  },
  {
    name: 'Sofia',
  },
];
